// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__lBPMM","animation":"Loading_animation__4DNgW","title":"Loading_title__027pV"};